<template>
  <div class="news-wrapper">

    <Head :lanshow="ActiveName" :title="$tc('header.back')" />
    <h5 class="mianbaoxie">
      <span> 当前地址：</span><span> 首页 </span>

      <span v-if="$route.query.name"> > {{ $route.query.name }}</span>
      <span> > 文章详情</span>
    </h5>
    <news-detail :detaildata="detailData"></news-detail>
    <Empty :emptydata="emptydata" v-if="emptydata" />
    <Footer :contact="contact" />
  </div>
</template>

<script>

import NewsDetail from '@/components/NewsDetail.vue'

import { mapMutations, mapState } from 'vuex'

export default {
  name: 'Video',
  data () {
    return {
      id: '',
      expireSign: '',
      detailData: null,
      emptydata: null,
      contact: null
    }
  },
  components: {
    NewsDetail
  },
  created () {
    this.id = this.$route.params.id
    this.expireSign = this.$route.query.expireSign
    this.getDate()
  },
  beforeRouteLeave (to, form, next) {
    // 视频退出问题尝试
    if (to.path != form.path) this.detailData = ''
    this.$Common.track('unload', {
      name: this.detailData && this.detailData.title,
      id: this.id,
      type: '资讯'
    }).then(() => {
      next()
    })
  },
  methods: {
    ...mapMutations(['setShowLoading']),
    getDate () {
      this.$Api.getNewsDetail({
        newsId: this.id,
        expireSign: this.expireSign
      }).then(data => {
        if (data) {
          data.item && (this.detailData = data.item)
          data.share && this.share(data.share)
          data.item && this.$Common.track('load', {
            title: data.item && data.item.title,
            id: this.id,
            type: '资讯'
          })
        } else {
          this.emptydata = {
            type: 'nodata'
          }
        }
        this.setShowLoading(false)

        if (data.item.videoLabelRelateList && data.item.videoLabelRelateList[0]) {
          data.item.videoAiLabels = data.item.videoLabelRelateList[0].labelRelateList.filter(item => item.labelId != -1)
        }
      }).catch((err) => {
        if (err === 404) {
          this.emptydata = {
            type: 'nodata'
          }
        } else {
          this.emptydata = {
            type: 'nonetwork'
          }
        }
        this.setShowLoading(false)
      })
      // 底部导航数据
      this.$Api.getHomeContact().then(res => {
        if (res) {
          this.contact = res.contact
        }
      }).catch()
    },
    share (obj) {
      this.$nextTick(() => {
        this.$Common.onshare(obj)
      })
    }
  },
  computed: {
    ...mapState(['ActiveName'])
  }
}
</script>
